export const adminEmail = 'hello@pulsedownloader.com';
